import { PublicClientApplication } from '@azure/msal-browser';
import { getAuthority, msalConfig } from './authConfig';

// Single MSAL instance shared by the app and the axios clients.
// Separate instances share the same cache but not interaction state, which causes interaction_in_progress errors.
const searchParams = new URLSearchParams(window.location.search);
const idTokenHint = searchParams.get('id_token_hint');

const msalInstance = new PublicClientApplication(msalConfig(getAuthority(idTokenHint)));

export default msalInstance;
